export default {
  1: '启用',
  0: '删除',
};
